import type { HTMLAttributes, ReactNode } from "react";

export interface CardProps extends Omit<HTMLAttributes<HTMLDivElement>, "title"> {
  title?: ReactNode;
  children: ReactNode;
}

export function Card({ title, className, children, ...rest }: CardProps) {
  const classes = ["ui-card", className].filter(Boolean).join(" ");
  return (
    <div className={classes} {...rest}>
      {title ? (
        <div className="ui-card__header">
          <h3 className="ui-card__title">{title}</h3>
        </div>
      ) : null}
      <div className="ui-card__body">{children}</div>
    </div>
  );
}
